export const MAX_ATTACHMENT_SIZE = '20mb'
export const MAX_ATTACHMENT_SIZE_MB = 20
export const MAX_PICTURE_SIZE = '20mb'
export const MAX_PICTURE_SIZE_MB = 20
